var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Steps',{attrs:{"stepNum":1}}),_c('Card1',{attrs:{"hasBtn":0}}),_c('Card2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }